import Http from './http.js'

const api = {
  // 普通用户
  userWechat: {
    userWeChatQRCode: params => Http.post({ url: '/modules/userWechat/userWeChatQRCode', params }), // 2.0 用户二维码
    userWechatDelete: params => Http.post({ url: '/modules/userWechat/userWechatDelete', params }) // 删除普通用户
  },
  // 工作人员
  userEmployees: {
    userEmployeesPublish: params => Http.post({ url: '/modules/userEmployees/userEmployeesPublish', params }), // 禁用和启用
    userAreaManagerPublish: params => Http.post({ url: '/modules/userEmployees/userAreaManagerPublish', params }), // 区域负责人禁用和启用
    userRecyclePublish: params => Http.post({ url: '/modules/userEmployees/userEmployeesPublish', params }) // 回收站人员禁用和启用
  },
  // 投递
  delivery: {
    userDeliveryGarbageHistoryList: params => Http.post({ url: '/modules/userDeliveryGarbage/userDeliveryGarbageHistoryList', params })
  },
  // 社区
  community: {
    communityNoPageList: params => Http.post({ url: '/modules/community/communityNoPageList', params }) // 社区下拉
  },
  // 商城管理
  mall: {
    // 耗材
    consumables: {
      consumablesAdd: params => Http.post({ url: '/modules/consumables/consumablesAdd', params }), // 新增耗材
      consumablesUpdate: params => Http.post({ url: '/modules/consumables/consumablesUpdate', params }), // 编辑耗材
      consumablesClearInventory: params => Http.post({ url: '/modules/consumables/consumablesClearInventory', params }) // 耗材库存清空
    },
    // 商品
    goods: {
      goodsIsPublish: params => Http.post({ url: '/modules/goods/goodsIsPublish', params }), // 上架或下架
      goodsIsPublishMultipart: params => Http.post({ url: '/modules/goods/goodsIsPublishMultipart', params }), // 批量上架或下架
      goodsIsHot: params => Http.post({ url: '/modules/goods/goodsIsHot', params }) // 热门
    }
  },
  // 站点管理
  siteManage: {
    site: {
      siteIsPublish: params => Http.post({ url: '/modules/site/siteIsPublish', params }), // 起禁用
      siteTreeList: params => Http.post({ url: '/modules/site/siteTreeList', params }), // 树形下拉
      siteTreeListByOrg: params => Http.post({ url: '/modules/site/siteTreeListByOrg', params }), // 树形联动
      siteOpenOrCloseDelivery: params => Http.post({ url: '/modules/site/siteOpenOrCloseDelivery', params }) // 批量开启关闭站点
    },
    goods: {
      siteGoodsAdd: params => Http.post({ url: '/modules/siteGoods/siteGoodsAdd', params }), // 新增
      siteGoodsEdit: params => Http.post({ url: '/modules/siteGoods/siteGoodsEdit', params }), // 编辑
      siteGoodsListNoAdd: params => Http.post({ url: '/modules/siteGoods/siteGoodsListNoAdd', params }) // 商品列表
    },
    org: {
      orgAdd: params => Http.post({ url: '/modules/org/orgAdd', params }), // 新增
      orgUpdate: params => Http.post({ url: '/modules/org/orgUpdate', params }), // 编辑
      orgDelete: params => Http.post({ url: '/modules/org/orgDelete', params }), // 删除
      orgListSelect: params => Http.post({ url: '/modules/org/orgListSelect', params }), // 机构下拉
      orgDetails: params => Http.post({ url: '/modules/org/orgDetails', params }), // 机构详情
      orgTreeList: params => Http.post({ url: '/modules/org/orgTreeList', params }), // 树形下拉
      orgTreeListNoSite: params => Http.post({ url: '/modules/org/orgTreeListNoSite', params }), // 联动下拉
      orgTreeAllListNoSite: params => Http.post({ url: '/modules/org/orgTreeAllListNoSite', params }) // 站点管理左侧树
    }
  },
  // 审批
  approval: {
    approveCarAdd: params => Http.post({ url: '/modules/approve/approveCarAdd', params }), // 出库
    approveGoodsAdd: params => Http.post({ url: '/modules/approve/approveGoodsAdd', params }), // 商品补货发货
    approveConsumablesAdd: params => Http.post({ url: '/modules/approve/approveConsumablesAdd', params }), // 耗材发货
    approveUpdateSystemAgree: params => Http.post({ url: '/modules/approve/approveUpdateSystemAgree', params }), // 审批同意
    approveUpdateSystemRefuse: params => Http.post({ url: '/modules/approve/approveUpdateSystemRefuse', params }), // 审批不同意
    updateConsumablesCountReal: params => Http.post({ url: '/modules/approveDetailConsumables/updateConsumablesCountReal', params }), // 耗材纠错实际数量
    updateGarbageCountReal: params => Http.post({ url: '/modules/approveDetailGarbage/updateGarbageCountReal', params }), // 垃圾纠错实际数量
    updateGoodsCountReal: params => Http.post({ url: '/modules/approveDetailGoods/updateGoodsCountReal', params }) // 商品纠错实际数量
  },
  // 统计
  statistical: {
    areaManager: {
      consumablesStatistical: params => Http.post({ url: '/modules/statisticalArea/consumablesStatistical', params }), // 耗材统计
      garbageStatistical: params => Http.post({ url: '/modules/statisticalArea/garbageStatistical', params }), // 可回收物投递出库统计
      goodsStatistical: params => Http.post({ url: '/modules/statisticalArea/goodsStatistical', params }), // 商品统计
      otherStatistical: params => Http.post({ url: '/modules/statisticalArea/otherStatistical', params }) // 其他类型统计
    },
    site: {
      consumablesStatistical: params => Http.post({ url: '/modules/statisticalSite/consumablesStatistical', params }), // 耗材统计
      garbageStatistical: params => Http.post({ url: '/modules/statisticalSite/garbageStatistical', params }), // 可回收物投递出库统计
      goodsStatistical: params => Http.post({ url: '/modules/statisticalSite/goodsStatistical', params }), // 商品统计
      otherStatistical: params => Http.post({ url: '/modules/statisticalSite/otherStatistical', params }) // 其他类型统计
    },
    points: {
      siteStatistical: params => Http.post({ url: '/modules/statisticalSite/siteStatistical', params }) // 积分统计
    },
    other: {
      otherStatistical: params => Http.post({ url: '/modules/statisticalOther/otherStatistical', params }) // 其他统计
    },
    activity: { // 活跃度
      activeStatistical: params => Http.post({ url: '/modules/statisticalActive/activeStatistical', params }) // 活跃度统计
    },
    pool: {
      integralPoolStatistical: params => Http.post({ url: '/modules/statisticalIntegralPool/integralPoolStatistical', params }) // 积分池统计
    },
    workbenchIndex: {
      // index: params => Http.get({ url: '/modules/ablPlatform/data', getParams: params }) // 统计
      index: params => Http.post({ url: '/modules/ablPlatform/data', params }) // 统计
    }
  },
  // 物业统计
  propertyStatistics: {
    deduct: {
      propertyStatistical: params => Http.post({ url: '/modules/statisticalProperty/propertyStatistical', params }) // 2.5.1.积分抵物业费统计
    },
    index: {
      integralPercent: params => Http.post({ url: '/modules/orgIntegral/integralPercent', params }) // 2.5.4.物业经营指标统计
    },
    outbound: {
      propertyStatisticalDeliveryOutbound: params => Http.post({ url: '/modules/statisticalProperty/propertyStatisticalDeliveryOutbound', params }) // 2.5.2.物业经营出入库统计
    },
    cross: {
      propertyStatisticalSettlement: params => Http.post({ url: '/modules/statisticalProperty/propertyStatisticalSettlement', params }) // 2.5.3.物业交叉结算统计
    }
  },
  // 预警管理
  warning: {
    record: {
      warnUpdate: params => Http.post({ url: '/modules/warn/warnUpdate', params }) // 更新预警记录
    },
    params: {
      warnTypeUpdate: params => Http.post({ url: '/modules/warnType/warnTypeUpdate', params }) // 参数值更新
    }
  },
  // 阈值设置
  threshold: {
    update: params => Http.post({ url: '/modules/threshold/update', params }) // 参数值更新
  }
}

export default api
